const mFindPwd = {
  name: 'mFindPwd',
  path: 'find-pwd',
  meta: {
    title: '找回密码'
  },
  component: resolve => require(['../../../pages/m/find-pwd'], resolve)
}

export default mFindPwd
